import React, { Component, } from 'react'
import { Col, Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input, } from 'reactstrap'
import { db } from '../../config/firebaseconfig'
import timestamper from '../../helpers/timestamper'
import queryString from 'query-string'
import getRequest from '../../helpers/getRequest'

const uuid = require('uuid/v1')

/* Manage Educators

  <AddClassesModal
    isOpen={this.props.modal === 'addClass'}
    key='AddClassModal'
    toggle={this.props.closeModal}
    select={this.props.select}
    educators={this.props.educators}
    selectedTeacher={this.props.selection.teacher}
    classes={this.props.classes}
  />
*/

class AddClassesModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      name: '',
      period: '',
      isSaving: false,
      error: '',
    }

    this.input = React.createRef()

  }


  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  cancel(id) {
    this.setState({
      name: '',
      period: '',
      isSaving: false,
      error: '',
    })
    this.props.toggle(id)
  }

  addClass() {
    this.setState({isSaving: true})
    let error = ''
    if (!this.state.name && !this.state.period) {
      error = 'Class name or period is required.'
    } 
    if (error) {
      this.setState({isSaving: false, error})
    } else {
      const id = uuid()
      const time = timestamper()
      
      // Eventually, make sure name and period are unique

      const teacher = this.props.educators[this.props.selectedTeacher]

      const batch = db.batch()
      const classRef = db.collection('classes').doc(id)
      const teacherRef = db.collection('educators').doc(teacher.id)

      batch.set(classRef, {
        id,
        name: this.state.name ? this.state.name : this.state.period,
        period: this.state.period,
        state: teacher.state,
        district: teacher.schoolDistrict,
        school: teacher.school,
        lastModified: time,
        created: time,
        teacher: teacher.id,
      })

      const key = `classes.${id}`
      batch.update(teacherRef, {[key]: true})

      batch.commit()
      .then(() => this.cancel(id))
      .catch((error) => {
        this.setState({error: 'Error saving class to database.', isSaving: false})
      })
       
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.input.current.focus()
    }
  }

  handleKeyPress(key) {
    if (key === 'Enter' && !this.state.isSaving) {
      this.addClass()
    }
  }

  render() {

    let submitButton = <Button className={'ml-2'} color='primary' onClick={() => this.addClass()}>Add Class</Button>
    if (this.state.isSaving) {
      submitButton = <Button className={'ml-2'} color='primary'><i className="fa fa-spinner fa-lg fa-spin"></i></Button>
    }

    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} className={'modal-primary'}>
        <ModalHeader toggle={this.props.toggle}>Add Class</ModalHeader>
        <ModalBody>
          <Form
            onKeyPress={(e) => this.handleKeyPress(e.key)}
          >
            <FormGroup>
              <Label htmlFor='name'>Name</Label>
              <Input 
                type='text' 
                id='name' 
                name='name' 
                placeholder='1st Period Geometry' 
                onChange={(e) => this.handleChange(e)} 
                value={this.state.name}
                className={this.state.error === 'Class name or period is required.' && !this.state.name && !this.state.period ? 'is-invalid' : null}              
                innerRef={this.input}
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor='period'>Period</Label>
              <Input 
                type='text' 
                id='period' 
                name='period' 
                placeholder='1st' 
                onChange={(e) => this.handleChange(e)} 
                value={this.state.period}
                className={this.state.error === 'Class name or period is required.' && !this.state.name && !this.state.period ? 'is-invalid' : null}              
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          {this.state.error ? `${this.state.error}` : ''}
          {submitButton}
          <Button onClick={() => this.cancel()} color='secondary'>Cancel</Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default AddClassesModal


// WEBPACK FOOTER //
// ./src/components/Users/AddClassesModal.js